import Gateway from '@/utils/Gateway';

export default function setFlowNext(step) {
    return Gateway.post('/v1/basic/corp/wework/flowNext', { step });
}
